import { render, staticRenderFns } from "./fab-registro-incidente.vue?vue&type=template&id=af72347e&"
import script from "./fab-registro-incidente.vue?vue&type=script&lang=js&"
export * from "./fab-registro-incidente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports